import Swiper from "swiper";
import { Pagination } from "swiper/modules";
Swiper.use([Pagination]);

const swiper = new Swiper(".hero-carousel", {
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,
  pagination: {
    el: ".hero-pagination",
    clickable: true,
  },
  // Responsive breakpoints
  breakpoints: {
    1024: {
      slidesPerView: 4,
      enabled: false,
    },
  },
});

const staffswiper = new Swiper(".staff-carousel", {
  slidesPerView: 1,
  spaceBetween: 20,
  autoHeight: true,
  pagination: {
    el: ".staff-pagination",
    clickable: true,
  },
  // Responsive breakpoints
  breakpoints: {
    768: {
      slidesPerView: 2,
      enabled: false,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.getElementById("menuButton");
  const desktopMenu = document.getElementById("desktopMenu");

  menuButton.addEventListener("click", function () {
    if (desktopMenu.style.opacity === "1") {
      closeNav();
    } else {
      openNav();
    }
  });
});

// Define the openNav and closeNav functions here
function openNav() {
  const desktopMenu = document.getElementById("desktopMenu");
  desktopMenu.style.minHeight = "fit-content";
  desktopMenu.style.maxHeight = "5000px";
  desktopMenu.style.opacity = "1";
  document.getElementById("site-content").classList.add("hidden");
}

function closeNav() {
  const desktopMenu = document.getElementById("desktopMenu");
  desktopMenu.style.minHeight = "0px";
  desktopMenu.style.maxHeight = "0px";
  desktopMenu.style.opacity = "0";
  document.getElementById("site-content").classList.remove("hidden");
}

// toggle submenu on click
document.addEventListener("DOMContentLoaded", function () {
  var menulinks = document
    .getElementById("menu-primary-menu")
    .querySelectorAll(".menu-item-has-children");

  if (menulinks) {
    menulinks.forEach(function (item) {
      item.addEventListener(
        "click",
        function (e) {
          // Removed active class from all other menu items
          menulinks.forEach(function (link) {
            link.classList.remove("active-sub-menu");
          }),
            // Adds active class to current sub menu
            item.classList.toggle("active-sub-menu");

          const subMenu = item.querySelector(".sub-menu");
          if (subMenu) {
            // Calculates width of submenu
            var containerWidth =
              document.querySelector(".container").offsetWidth;
            var subMenuWidth = containerWidth - 288;
            subMenu.style.width = subMenuWidth + "px";

            // Calculates height of submenu to set height of menu container
            var subMenuHeight = subMenu.offsetHeight;

            document.getElementById("menu-primary-menu").style.minHeight =
              subMenuHeight + "px";
          }
        },
        false
      );
    });
  }

  menuItems.forEach((menuItem) => {
    const subMenu = menuItem.querySelector(".sub-menu");

    menuItem.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent the click from reaching the document body

      // Toggle the 'display' style property of the sub-menu
      if (subMenu) {
        var containerWidth = document.querySelector(".container").offsetWidth;
        var subMenuWidth = containerWidth - 288;

        subMenu.style.width = subMenuWidth + "px";

        if (subMenu.style.display === "grid") {
          subMenu.style.display = "none";
          menuItem.style.color = "#10274A";
        } else {
          subMenu.style.display = "grid";
          menuItem.style.color = "#E74F6C";

          var subMenuHeight = subMenu.offsetHeight;
          if (window.innerWidth >= 1024) {
            document.getElementById("menu-primary-menu").style.minHeight =
              subMenuHeight + "px";
          }
        }
      }

      // Hide other open sub-menus
      menuItems.forEach((otherMenuItem) => {
        if (otherMenuItem !== menuItem) {
          const otherSubMenu = otherMenuItem.querySelector(".sub-menu");
          if (otherSubMenu && otherSubMenu.style.display === "grid") {
            otherSubMenu.style.display = "none";
            otherMenuItem.style.color = "#10274A";
          }
        }
      });
    });
  });

  // Close the sub-menu when clicking anywhere outside the menu
  document.body.addEventListener("click", function () {
    menuItems.forEach((menuItem) => {
      this.classList.remove("active-sub-menu");
    });
  });
});
